import { call, put, takeEvery } from "redux-saga/effects"

import { 
    GET_EVALUATIONS, 
    ADD_NEW_EVALUATION, 
    UPDATE_EVALUATION, 
    DELETE_EVALUATION,
    GET_AVERAGE_BY_EVALUATION
} from "./actionTypes";
import {
    getEvaluationsSuccess,
    getEvaluationsFail,
    addEvaluationSuccess,
    addEvaluationFail,
    updateEvaluationSuccess,
    updateEvaluationFail,
    deleteEvaluationSuccess,
    deleteEvaluationFail,

    getAverageByEvaluationSuccess,
    getAverageByEvaluationFail

   
} from "./actions"

import {
    getEvaluations,
    addNewEvaluation,
    updateEvaluation,
    deleteEvaluation,

    getAverageByEvaluation
   
} from "helpers/evaluations/evaluations_backend_helper";
import { toast } from "react-toastify";

/*
function* fetchEvaluations() {
    try {
        const response = yield call(getEvaluations)
        yield put(getEvaluationsSuccess(response))
    } catch (error) {
        yield put(getEvaluationsFail(error))
    }
}
*/

function* fetchEvaluations({ payload }) {
    try {
        // On passe les params (session_uuid) à l'appel API
        const response = yield call(getEvaluations, payload); 
        console.log("Saga Response Check:", response); // Regarde la console !
        yield put(getEvaluationsSuccess(response));
    } catch (error) {
        yield put(getEvaluationsFail(error));
    }
}



function* onAddNewEvaluation({ payload }) {
    try {

        
        const response = yield call(addNewEvaluation, payload)

        console.log("RESPONSE:", response);
        yield put(addEvaluationSuccess(response.evaluation))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        console.log("ERROR:", error);
        yield put(addEvaluationFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}



function* onUpdateEvaluation({ payload}) {
    try {
        console.log("UPDATE: ", payload);
        const response = yield call(updateEvaluation, payload)
        yield put(updateEvaluationSuccess(response.evaluation))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(updateEvaluationFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

function* onDeleteEvaluation({ payload: data }) {

    try {
        const response = yield call(deleteEvaluation, data)
        yield put(deleteEvaluationSuccess(response.evaluationId))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(deleteEvaluationFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

function* onGetAverageByEvaluation({ payload: evaluationUuid }) {
    try {
        const response = yield call(getAverageByEvaluation, evaluationUuid);
        yield put(getAverageByEvaluationSuccess(response));
    } catch (error) {
        yield put(getAverageByEvaluationFail(error));
    }
}


function* evaluationSaga() {
    yield takeEvery(GET_EVALUATIONS, fetchEvaluations)
    yield takeEvery(ADD_NEW_EVALUATION, onAddNewEvaluation)
    yield takeEvery(UPDATE_EVALUATION, onUpdateEvaluation)
    yield takeEvery(DELETE_EVALUATION, onDeleteEvaluation)
    // Moyennes
    yield takeEvery(GET_AVERAGE_BY_EVALUATION, onGetAverageByEvaluation);
}

export default evaluationSaga;